import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { Helmet } from 'react-helmet';

import theme from '~/theme';

import './global.css';
import { HelmetSeo } from '~/components/HelmetSeo';

/**
 * This is the default layout without header and footer components
 */
const BaseMin: React.FC = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <Helmet
        htmlAttributes={{
          lang: 'de',
        }}
      >
        <meta charSet="utf-8" />
      </Helmet>
      <HelmetSeo />

      <main>{children}</main>
    </ThemeProvider>
  );
};

export default BaseMin;
